export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/shared/enums/CartItemType.ts